export default __webpack_public_path__ + "static/media/slider31.276955f4.jpg";